import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import * as moment from 'moment';
import { AgendaService } from 'src/app/services/agenda/agenda.service';
import { EventResource, SuperTypeEnum } from 'src/app/utils/interfaces/new/event-resource.interface';
import { EventType } from 'src/app/utils/interfaces/new/event-type.interface';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { ProchainCreneau } from 'src/app/utils/interfaces/new/ProchainCreneau';
import { environment } from 'src/environments/environment';

interface SlotsTableDisplay {
  periode: string;
  description: string;
  resourceName: string;
  meta: ProchainCreneau
}

@Component({
  selector: 'app-next-slot',
  templateUrl: './next-slot.component.html',
  styleUrls: [
    './next-slot.component.scss',
    '../../../../fragments/modal/modal.fragment.scss'
  ]
})
export class NextSlotComponent implements OnInit {

  public eventTypes: Array<EventType>;
  public lengths: Array<string>;
  public resource: EventResource;
  public resources: Array<EventResource> = [];

  public eventTypesLabel: Array<string> = [];
  public resourcesLabel: Array<string> = [];

  public searchResult: Paginated<SlotsTableDisplay>;
  public periodesColumnTable = [
    { title: 'Période', data: 'periode' },
    { title: 'Description', data: 'description' },
    { title: 'Ressource', data: 'resourceName' }
  ];
  public errorMsg = '';
  public noResult = false;

  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;

  @Output() public closeEmitter = new EventEmitter();

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
        this.closeModal(null);
    }
  }

  public formGroup: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private agendaSrv: AgendaService
  ) { }

  ngOnInit(): void {
    this.eventTypesToString();

    this.resourcesToString();

    this.initForm();
  }

  private initForm() {
    if (!this.resource) {
      setTimeout(() => {
        this.initForm();
      }, 100);
    } else {
      this.formGroup = this.formBuilder.group({
        date: [new Date()],
        selectLength: ['length'],
        length: ['15'],
        type: [''],
        resource: [this.resource.nom],
        allOffice: [false]
      });
    }
  }

  private eventTypesToString() {
    if (!this.eventTypes || this.eventTypes.length === 0) {
      setTimeout(() => {
        this.eventTypesToString();
      }, 0);
    } else {
      for (const t of this.eventTypes) {
        this.eventTypesLabel.push(t.label);
      }

      if (this.formGroup) {
        this.formGroup.get('type').patchValue(this.eventTypesLabel[0]);
      }
    }
  }

  private resourcesToString() {
    if (!this.resources || this.resources.length === 0) {
      setTimeout(() => {
        this.resourcesToString();
      }, 0);
    } else {
      for (const r of this.resources) {
        // On n'affiche que les ressources de type profil
        if (r.superType === SuperTypeEnum.Profil) {
          this.resourcesLabel.push(r.nom);
        }
      }
    }
  }

  public closeModal(slot?: any): void {
    this.closeEmitter.emit(slot);
  }

  public async doSearchEvents() {
    if (this.formGroup.get('selectLength').value === 'length' && (!this.formGroup.get('length').value || this.formGroup.get('length').value === '')) {
      this.errorMsg = 'La durée ne peut pas être vide';

      setTimeout(() => {
        this.errorMsg = '';
      }, 3000);

      return;
    }

    if (this.formGroup.get('selectLength').value === 'type' && (!this.formGroup.get('type').value || this.formGroup.get('type').value === '')) {
      this.errorMsg = 'Le type ne peut pas être vide';

      setTimeout(() => {
        this.errorMsg = '';
      }, 3000);

      return;
    }

    let slotLength: string | undefined = undefined;
    if (this.formGroup.get('selectLength').value === 'length') {
      slotLength = this.formGroup.get('length').value;
    }

    let typeId: string | undefined = undefined;
    if (this.formGroup.get('selectLength').value === 'type') {
      typeId = this.eventTypes.find(t => t.label === this.formGroup.get('type').value).id;
    }

    const allOffice = this.formGroup.get('allOffice').value;

    const selectedResourceName = this.formGroup.get('resource').value;
    const resource = this.resources.find(r => r.nom === selectedResourceName);

    let date = this.formGroup.get('date').value;
    if (moment(this.formGroup.get('date').value).isSame(moment(), 'day')) {
      date = moment().hour(moment().hour()).minute(moment().minute()).second(moment().second()).millisecond(0).toDate();
    }

    const result = await this.agendaSrv.getNextSlot(date, slotLength, typeId, !allOffice ? resource : undefined, allOffice);

    if (!result || result.length === 0) {
      this.noResult = true;
      return;
    } else {
      this.noResult = false;
    }

    const resultDisplay: Array<SlotsTableDisplay> = [];

    for (const r of result) {
      resultDisplay.push({
        periode: `${moment(r.dateDebut).format('HH:mm')} - ${moment(r.dateFin).format('HH:mm')}`,
        description: r.description,
        resourceName: r.ressource.nom,
        meta: r
      });
    }

    if (this.searchResult) {
      this.searchResult.objects = [...resultDisplay];
    } else {
      this.searchResult = {
        objects: [...resultDisplay],
        page: 0,
        perpage: 0,
        total: 0
      };
    }
  }

  public selectSlot(slot: SlotsTableDisplay) {
    let typeId: string | undefined = undefined;
    if (this.formGroup.get('selectLength').value === 'type') {
      typeId = this.eventTypes.find(t => t.label === this.formGroup.get('type').value).id;
    }

    this.closeModal({
      slotStart: moment(slot.meta.dateDebut).toDate(),
      slotEnd: moment(slot.meta.dateFin).toDate(),
      resourceId: slot.meta.ressource.id,
      eventTypeId: typeId,
      resourceType: 'profil',
      resourceName: slot.resourceName
    });
  }

}
